import React from 'react';
import PropTypes from 'prop-types';
import { StyledModalContent } from './Styles';
function ModalContent(_ref) {
  var children = _ref.children,
    disableGutter = _ref.disableGutter;
  return /*#__PURE__*/React.createElement(StyledModalContent, {
    disableGutter: disableGutter
  }, children);
}
ModalContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Contents to display inside dialog
   */
  children: PropTypes.node.isRequired,
  /**
   * If `true`, will not add any padding.
   */
  disableGutter: PropTypes.bool
} : {};
ModalContent.defaultProps = {
  disableGutter: false
};
export default ModalContent;